import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const Schedule = ({className, ...props}) => (
  _jsxs('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: [
    _jsx('path', { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"                          ,} )
    , _jsx('path', { d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"  ,} )
  ]})
)

export default Schedule
